import * as Types from '../../../../../__generated__/schema';

import {
  ActorTeaserAPIToken,
  ActorTeaserUser,
} from '../../../../graphql/fragments/ActorTeaser.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import { ActorTeaser } from '../../../../graphql/fragments/ActorTeaser.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateCommentVariables = Types.Exact<{
  input: Types.CreateAlertCommentInput;
}>;

export type CreateComment = {
  createAlertComment: {
    comment: Pick<Types.Comment, 'id' | 'body' | 'format' | 'createdAt'> & {
      createdBy: ActorTeaserAPIToken | ActorTeaserUser;
    };
  };
};

export const CreateCommentDocument = gql`
  mutation CreateComment($input: CreateAlertCommentInput!) {
    createAlertComment(input: $input) {
      comment {
        id
        body
        format
        createdAt
        createdBy {
          ...ActorTeaser
        }
      }
    }
  }
  ${ActorTeaser}
`;
export type CreateCommentMutationFn = Apollo.MutationFunction<
  CreateComment,
  CreateCommentVariables
>;

/**
 * __useCreateComment__
 *
 * To run a mutation, you first call `useCreateComment` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateComment` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createComment, { data, loading, error }] = useCreateComment({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateComment(
  baseOptions?: Apollo.MutationHookOptions<CreateComment, CreateCommentVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateComment, CreateCommentVariables>(CreateCommentDocument, options);
}
export type CreateCommentHookResult = ReturnType<typeof useCreateComment>;
export type CreateCommentMutationResult = Apollo.MutationResult<CreateComment>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<
  CreateComment,
  CreateCommentVariables
>;
export function mockCreateComment({
  data,
  variables,
  errors,
}: {
  data: CreateComment;
  variables?: CreateCommentVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: CreateCommentDocument, variables },
    result: { data, errors },
  };
}
